/**
 * 악덕알리미(/b) 사이트 부트스트랩
 *
 * 모든 /b 페이지 진입 시 1회 실행 (app.js → loadSiteBootstrap('Devil')).
 * 테마/글자크기 제어 + 공용 유틸(번호·상호 마스킹)을 window.BD 로 노출한다.
 * 활성 탭 표시는 서버(blade tabbar partial)에서 처리하므로 여기서 다루지 않는다.
 */

const FS_LIST = ['m', 'l', 'xl'];      // 장비불러(JB)와 동일 스케일 — <html data-fs> 속성
const THEME_LIST = ['light', 'dark'];  // 악덕알리미는 'auto' 없음 (설정화면에 항목이 없다)

// localStorage 키 — ⚠ 경계키: PHP 쪽 App\Common\ThemeBoot::KEYS['BD'] 와 값이 같아야 한다 (개명은 양쪽 동시에).
const K_THEME = 'b:ui:theme';
const K_FS    = 'b:ui:fontSize';

/* ── 개발용 서버(도메인) 전환 진입 — 상단 영역 아무데나 7연속 탭(500ms 내) ──
 * jb 의 헤더 7탭 이스터에그와 동일 UX. devil 은 공통 상단바가 없어 특정 요소 대신
 * "화면 상단 영역(clientY < ZONE)"의 탭을 센다 → 중앙/좌/우 어디든 상단이면 인식.
 * 7회 완성 시 진동 + $j.F.Devil.DevBridge.open(). */
function initDevTrigger() {
    const N = 7, W = 500, ZONE = 130;   // 상단 130px 이내
    let c = 0, tm = null;
    $(document).on('click', (e) => {
        if ((e.clientY == null ? 9999 : e.clientY) > ZONE) return;   // 상단 영역 밖 탭은 무시
        c++;
        if (tm) clearTimeout(tm);
        if (c >= N) {
            c = 0; tm = null;
            if (navigator.vibrate) navigator.vibrate(40);
            if ($j.F.Devil && $j.F.Devil.DevBridge) $j.F.Devil.DevBridge.open();
            return;
        }
        tm = setTimeout(() => { c = 0; tm = null; }, W);
    });
}

// 화면모드/글자크기는 **기기(localStorage)** 단일 소스 — 서버에 저장하지 않는다.
// 로드 시엔 <head> 의 부트 스크립트(App\Common\ThemeBoot)가 같은 키를 읽어 속성을 붙인다(FOUC 없음).
// 라이트·보통은 속성을 붙이지 않는다 — CSS `:root`(base/_theme.scss) 가 곧 라이트·보통이다.
// 로그인 전에는 화면모드·글자크기를 걸지 않는다 — 부트 스크립트(ThemeBoot::MEMBER_ONLY)와 같은 기준.
const loggedIn = () => typeof MEMBER !== 'undefined' && !!MEMBER && !!MEMBER.num;

const BD = {
    /* ── 테마 (light|dark) ───────────────────────────── */
    getTheme() {
        return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    },
    setTheme(theme) {
        if (!THEME_LIST.includes(theme) || !loggedIn()) return;
        $j.Common.Store.local.set(K_THEME, theme);
        if (theme === 'dark') document.documentElement.setAttribute('data-theme', 'dark');
        else document.documentElement.removeAttribute('data-theme');
    },
    toggleTheme() {
        this.setTheme(this.getTheme() === 'dark' ? 'light' : 'dark');
    },

    /* ── 글자 크기 (m|l|xl) — 장비불러와 동일하게 <html data-fs> 속성 ── */
    getFontSize() {
        const v = document.documentElement.getAttribute('data-fs');
        return FS_LIST.includes(v) ? v : 'm';
    },
    setFontSize(size) {
        if (!FS_LIST.includes(size) || !loggedIn()) return;
        $j.Common.Store.local.set(K_FS, size);
        if (size === 'm') document.documentElement.removeAttribute('data-fs');
        else document.documentElement.setAttribute('data-fs', size);
    },

    /* ── 마스킹 유틸 (표시 보조 — 실제 마스킹은 서버에서 강제) ── */
    // 상호/이름: 뒤 절반을 * 처리
    maskName(t) {
        if (!t) return t;
        const m = Math.ceil(t.length / 2);
        return '*'.repeat(m) + t.slice(m);
    },
    // 전화: 국번 앞 2자리만 * 처리 (010-**32-**44)
    maskPhone(p) {
        if (!p) return p;
        const pts = String(p).split('-');
        if (pts.length !== 3) return this.maskName(p);
        return `${pts[0]}-${'**' + pts[1].slice(2)}-${'**' + pts[2].slice(2)}`;
    },

    /* ── 토스트 (악덕알리미 테마) ─────────────────── */
    toast(msg, dur = 1800) {
        $('.b-toast').remove();
        const $t = $('<div class="b-toast"></div>').text(msg);
        $('body').append($t);
        requestAnimationFrame(() => $t.addClass('is-show'));
        setTimeout(() => {
            $t.removeClass('is-show');
            setTimeout(() => $t.remove(), 300);
        }, dur);
    },
};

export default {
    initialize() {
        window.BD = BD;

        // 하위 페이지 헤더 뒤로(includes/header·report) — data-back 이 있으면 그 주소로 replace, 없으면 history.back()
        $(document).on('click', '.b-header__back', function () {
            if (this.dataset.back) location.replace(this.dataset.back);
            else history.back();
        });

        // header:'slot' + dragBar — 슬롯 헤더(장비불러·모바일관리자와 같다). 닫기 X 는 그대로.
        // 손잡이는 fullScreen 이라 그려지지 않는다(전체화면 시트엔 끌어 내릴 낱장이라는 단서가 필요 없다 — BS.js).
        // 박스형 닫기·하단 보더 같은 악덕 모양은 devil/components/_bs-devil.scss 가 --ui-bs-* 로 준다.
        // titleAlign:'left' — 악덕 시트 제목은 원래부터 왼쪽(뱃지+대표번호 같은 긴 제목). 장비불러는 가운데.
        // dimOpacity — 시트 위로 살짝 보이는 뒷페이지 제목이 기본 dim(.5)에서는 잘 안 읽혀서
        // 악덕알리미만 옅게(2026-08 기획자 피드백). 다른 사이트(장비불러 등) 기본값은 그대로.
        // fullScreen — 시트가 화면 전체를 덮는다(2026-09-14 CEO 피드백). dimOpacity 는 열리고 닫히는 순간에만 보인다.
        // looseDrag — 드래그 닫기 판정 완화(60px/속도기준)+본문 드래그 허용. 악덕알리미만 켠다 —
        // 장비불러·모바일관리자는 시트 안 입력 폼이 많아 완화하면 입력 유실 위험(2026-08 상필 님 QA).
        // stopAnywhere — 끌어내리다 손 떼면 그 자리에 멈춘다(2026-10 홍과장님 요청. 장비불러에도 켬).
        $j.Ui.BS.init({ header: 'slot', titleAlign: 'left', dragBar: true, dimOpacity: .35, looseDrag: true, fullScreen: true, stopAnywhere: true });

        // 확인·알림창($j.Ui.Dialog)도 악덕 모달 테마('devil')를 기본으로 — 글자크기 확대(크게·아주크게)가
        // .ui-modal--v-devil 에만 걸려 있어서(base/_helpers.scss), 호출부가 variant 를 안 적으면 그 창만 작게 떴다
        // (2026-10-20 상필 님 QA: 제보하기·로그아웃 확인창). 여기서 한 번 정하면 앞으로 새 확인창도 빠지지 않는다.
        $j.Ui.Dialog.setDefaults({ variant: 'devil' });

        // ajax 401(세션 끊김)이면 /b/login 으로 — 장비불러(/m)와 같은 처리, 로그인 화면만 악덕 것.
        //   악덕 자동로그인(JBREM)은 /b/login 화면을 열 때만 돈다 — ajax 는 세션(120분)이 끝나면 401 만 받는다.
        //   이게 없어서 앱을 켜 둔 채 오래 지난 뒤 알림 카드·통화 팝업 [상세보기] 가 '불러오기 실패' 로 멈췄다(2026-10-27 대표님).
        //   sessionOnly — 다른 실패는 화면마다 '불러오기 실패' 로 이미 알린다. start() 를 안 쓰는 이유는 /ma 와 같다(배너 CSS 가 m.css 에만 있음).
        $j.Common.Network.setupAjax({ loginUrl: '/b/login', sessionOnly: true });

        // 주소 검색 레이어 — 폰 뒤로가기로 레이어만 닫고(backClose), 머리를 제목 + × 로(titleBar). 기본값(다른 사이트)은 둘 다 꺼짐.
        $j.F.Postcode.init({ backClose: true, titleBar: true });

        // 가로 스크롤 탭·칩 줄의 '더 있다' 힌트 — 마크업의 [data-scroll-fade] 에 붙인다. JS 로 나중에 그린 곳은 각 모듈이 attachAll(root).
        $j.Ui.ScrollFade.attachAll();

        // 당겨서 새로고침 — 장비불러(모바일)와 동일 컴포넌트. 악덕알리미는 body가 아니라
        // 내부 .b-scroll div가 실제 스크롤러라 대상을 지정해서 켠다(PullRefresh.js 참고).
        // textLoading:'' — 로딩 문구("새로운 내용을 불러오고 있어요")가 제목("체불 리스트" 등)과
        // 겹쳐 보여서(상필 님 QA) 로딩 중엔 스피너만 남기고 뺐다. 모바일(jb)은 그대로 유지.
        // 제보 작성(Report)·설정(Settings)은 켜지 않는다 — 긴 폼·설정 목록을 위로 스크롤하다 당겨지면
        // 새로고침으로 입력·토글 상태가 흔들린다(2026-09-11 상필 님 QA). 둘 다 새로 불러올 목록이 없다.
        if (!['Report', 'Settings'].includes(document.body.dataset.pageName)) {
            $j.Ui.PullRefresh.enable({ scroller: '.b-scroll', textLoading: '' });
        }

        initDevTrigger();      // 상단 타이틀 7연속 탭 → 서버(도메인) 전환 BS

        // 화면모드/글자크기는 <head> 부트 스크립트가 첫 페인트 전에 이미 반영했으므로 여기서 복원할 필요 없음.

        // 네이티브(BD) 동기화 — 모든 /b 페이지 공통 1회: push.alertMode + member.mbno
        // (페이지별 산발 호출 대신 부트스트랩에서 일괄 처리. 앱 외 환경이면 자동 no-op.)
        $j.F.Devil.App.syncSettings();
        // 기기정보·환경 스냅샷 등록 — 반드시 syncSettings 뒤(앱은 회원번호를 받은 뒤에야 스냅샷을 만든다)
        $j.F.Devil.App.registerDevice();

        // 앱 업데이트 게이트 — 장비불러와 같은 모듈, 옵션만 BD 로.
        //   playstore:false — 악덕알리미는 원스토어 배포다. openPlaystore 는 이름 그대로
        //   플레이스토어 전용이라 수락되면 그 앱이 없는 스토어가 열린다.
        //   storeMinVer — 앱이 openStore 로 원스토어를 열 수 있는 첫 버전. 여기부터 업데이트 버튼을 보여 준다.
        //   storeGuide — 그보다 낮거나 버전을 모르면 버튼 대신 이 문구를 보여 준다.
        // 서버 조회는 로그인당 1회고(그 뒤 세션 캐시), 강제 판정만 매 페이지 다시 그린다.
        $j.F.AppGate.start({
            app: 'BD', url: '/b/ajax/app-version', playstore: false,
            storeMinVer: 1.751,
            storeGuide: '원스토어 앱을 열어 악덕알리미를 업데이트해 주세요.',
            // 악덕알리미에는 오더가 없다. 이 앱을 쓰는 이유는 체불업체 전화 경고다.
            why: '업데이트해야 체불업체 경고를 정상으로 받을 수 있습니다.',
        });

        // 앱 '악덕업체보기'($j.F.App.devilMaster) — 악덕마스터번호로 상세 BS 표시.
        // 모든 /b 페이지 공통 구독. Home 알림 클릭(Home.js)과 동일 진입점($j.F.Devil.Master) 사용.
        $j.Common.EventBus.on('Sites.Devil.Bootstrap', 'app:devil:master', (e, data) => {
            const num = data && data.master_num;
            if (num) $j.F.Devil.Master.open(num);
        });

        // 세션이 끝나 로그인을 다녀왔으면 그때 누른 업체 상세를 이어서 연다(F/Devil/Master.js 머리말)
        $j.F.Devil.Master.resumePending();

        // (제거됨) 탭바 이동 전체화면 로딩 오버레이 — 셸을 가려 오히려 "한참 도는 스피너"로 체감됐다.
        // main.js/b.js defer 로 셸이 먼저 페인트되므로(JB 처럼) 별도 오버레이 불필요.
    }
};
